import { render, staticRenderFns } from "./uploadIntLabel.vue?vue&type=template&id=e6a1ec4c&scoped=true&"
import script from "./uploadIntLabel.vue?vue&type=script&lang=js&"
export * from "./uploadIntLabel.vue?vue&type=script&lang=js&"
import style0 from "./uploadIntLabel.vue?vue&type=style&index=0&id=e6a1ec4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a1ec4c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
